import { delegate } from '../lib/dom';

/**
 * Mobile nav toggle.
 *
 * `.menu-toggle.is-active + .site-navigation` is what actually reveals the menu
 * (see theme.min.css), and `body.menu-open` locks the page behind it.
 */
export function mobileMenu(): void {
  delegate(document, 'click', '.menu-toggle', (toggle, event) => {
    // Keep the document-level handler in desktopMenu from immediately closing us.
    event.stopPropagation();
    const open = toggle.classList.toggle('is-active');
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });
}
